<div class="row" [ngClass]="!isMobile && 'mt-5 mb-2'">
	<div class="row d-flex justify-content-start">
		<!--BUTTONS-->
		<div class="d-flex">
			<div
				*ngIf="isDisplayableAddDropdownButton()"
				class="dropdown me-2 flex-fill"
			>
				<button
					class="btn theme-green-button h-100 w-100"
					type="button"
					id="addDropdownButton"
					data-bs-toggle="dropdown"
					aria-expanded="false"
					[disabled]="isLoadingSolution"
				>
					<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i>
					Ajouter
				</button>

				<ul class="dropdown-menu w-100" aria-labelledby="addDropdownButton">
					<li>
						<a
							class="dropdown-item theme-main-color"
							role="button"
							(click)="openModalCreateVacation()"
							>Absence</a
						>
					</li>
					<!--  
						<li>
							<a class="dropdown-item theme-main-color" role="button">{{
								labelInterventionCapitalized
							}}</a>
						</li>
					-->
				</ul>
			</div>

			<button
				*ngIf="isDisplayableReportAndCoordinationButtons()"
				[disabled]="isLoadingSolution"
				class="btn theme-bs-light-button me-2 flex-fill"
				(click)="openSolutionNotes()"
			>
				<i class="bi bi-pencil-square fs-5" aria-hidden="true"></i> Coordination
			</button>
			<button
				*ngIf="isDisplayablePlanifierButton()"
				[disabled]="isLoadingSolution"
				class="btn theme-green-button me-2 flex-fill"
				(click)="openPlanifModal()"
			>
				<i class="fs-5 bi bi-calendar2-check" aria-hidden="true"></i>
				<span class="isybuddy"></span> Planifier
			</button>
			<button
				*ngIf="isDisplayableValidateButton()"
				[disabled]="isLoadingSolution"
				class="btn theme-bs-light-button me-2 flex-fill"
				(click)="openValidatePlanningModal()"
			>
				<i class="bi bi-unlock-fill" aria-hidden="true"></i> Valider
			</button>
			<button
				*ngIf="isDisplayableUnlockButton()"
				[disabled]="isLoadingSolution"
				class="btn theme-bs-light-button me-2 flex-fill"
				(click)="openInvalidatePlanningModal(invalidatePlanningModal)"
			>
				<i class="bi bi-lock-fill" aria-hidden="true"></i> Déverrouiller
			</button>
			<button
				*ngIf="isDisplayableReportAndCoordinationButtons()"
				[disabled]="isLoadingSolution || isDisabledReportButton"
				class="btn theme-bs-light-button me-2 flex-fill"
				(click)="openOptimizationReport(optimizationReport)"
			>
				<i class="bi bi-clipboard-data fs-5" aria-hidden="true"></i> Rapport
			</button>
			<div
				*ngIf="isDisplayableDownloadDropdownButton()"
				class="dropdown me-2 flex-fill"
			>
				<button
					class="btn theme-bs-light-button h-100 w-100"
					type="button"
					id="downloadDropdownButton"
					data-bs-toggle="dropdown"
					aria-expanded="false"
					[disabled]="isLoadingSolution || !isClickableDownloadDropdownButton()"
				>
					<i class="bi bi-download fs-5" aria-hidden="true"></i> <br />
					Télécharger
				</button>

				<ul class="dropdown-menu" aria-labelledby="downloadDropdownButton">
					<li>
						<a
							class="dropdown-item theme-main-color"
							*ngIf="isDisplayableExportAsListButtonInDropdown()"
							(click)="
								exportAsListPDF(solution, selectedWeek, beginDate, endDate)
							"
							type="button"
							>Liste</a
						>
					</li>
					<li *ngIf="isDisplayableExportButtonInDropdown()">
						<a
							class="dropdown-item theme-main-color"
							type="button"
							(click)="exportAsPDF()"
							>Planning</a
						>
					</li>
					<li *ngIf="isDisplayableExportButtonInDropdown()">
						<a
							class="dropdown-item theme-main-color"
							type="button"
							(click)="downloadFile()"
							>Excel</a
						>
					</li>
					<li *ngIf="isDisplayableGoogleOutlookExportButton()">
						<a
							class="dropdown-item theme-main-color"
							role="button"
							(click)="openExportCalendarModal()"
							>Agendas externes (Google, Outlook etc.)
						</a>
					</li>
				</ul>
			</div>
			<button
				class="btn theme-bs-light-button flex-fill"
				type="button"
				*ngIf="isDisplayableCopyButton()"
				[disabled]="isLoadingSolution"
				(click)="openCopyDataModal()"
			>
				<i class="bi bi-clipboard-plus fs-5" aria-hidden="true"></i>
				<br />
				Copier vers...
			</button>
			<!-- LOADER QUAND ON EST PAS EN VUE MOBILE (SITUÉ AU MÊME ENDROIT QUE D'HABITUDE)-->
			<div class="text-center flex-fill" *ngIf="isDisplayableLoader()">
				<div class="mt-2 lds-dual-ring"></div>
			</div>
		</div>
	</div>

	<div class="mt-4">
		<div class="row justify-content-between">
			<!-- Sélecteur semaine -->
			<div class="col">
				<div
					class="row justify-content-center"
					*ngIf="isDisplayableWeekSelectorMobile()"
				>
					<div class="row theme-main-color d-flex justify-content-center mb-4">
						<div
							class="vw-75 text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							(click)="resetDateClick()"
						>
							<span>Semaine {{ selectedWeek }} </span
							><span class="fw-bold">{{
								daysFr[selectedCalendarDate.getDay()] +
									' ' +
									selectedCalendarDate.getDate() +
									' ' +
									monthsFr[selectedCalendarDate.getMonth()] +
									' ' +
									selectedYear
							}}</span>
						</div>
					</div>
					<div class="row theme-main-color d-flex justify-content-evenly">
						<div
							class="col-6 d-flex justify-content-start align-items-center date-nav-btn rounded-pill theme-main-border-color"
							mwlCalendarPreviousView
							[view]="view"
							[(viewDate)]="selectedCalendarDate"
							#prev
							(click)="previousClick(selectedCalendarDate)"
							role="button"
						>
							<i class="bi bi-chevron-left fs-2 pe-1" aria-hidden="true"></i>
							Précédent
						</div>
						<div
							class="col-6 d-flex justify-content-end align-items-center date-nav-btn rounded-pill theme-main-border-color"
							mwlCalendarNextView
							[view]="view"
							[(viewDate)]="selectedCalendarDate"
							#next
							(click)="nextClick(selectedCalendarDate)"
							role="button"
						>
							Suivant
							<i class="bi bi-chevron-right fs-2 ps-1" aria-hidden="true"></i>
						</div>
					</div>
				</div>

				<div
					class="row"
					*ngIf="isDisplayableWeekSelectorInViewDay()"
					[ngClass]="isMobile && 'justify-content-center'"
				>
					<div
						class="theme-main-color d-flex"
						[ngClass]="isMobile && 'justify-content-center'"
					>
						<div
							class="vw-5 align-self-center text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							mwlCalendarPreviousView
							[view]="view"
							[(viewDate)]="selectedCalendarDate"
							#prev
							(click)="previousClick(selectedCalendarDate)"
						>
							<i class="bi bi-chevron-left fs-4" aria-hidden="true"></i>
						</div>
						<div
							class="vw-30 text-center mt-2 hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							(click)="resetDateClick()"
						>
							<span>Semaine {{ selectedWeek }} </span
							><span class="fw-bold">{{
								daysFr[selectedCalendarDate.getDay()] +
									' ' +
									selectedCalendarDate.getDate() +
									'
						' +
									monthsFr[selectedCalendarDate.getMonth()] +
									'
						' +
									selectedYear
							}}</span>
						</div>

						<div
							class="vw-5 align-self-center text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							mwlCalendarNextView
							[view]="view"
							[(viewDate)]="selectedCalendarDate"
							#next
							(click)="nextClick(selectedCalendarDate)"
						>
							<i class="bi bi-chevron-right fs-4" aria-hidden="true"></i>
						</div>
					</div>
				</div>
				<div class="row" *ngIf="isDisplayableWeekSelectorInViewWeek()">
					<div
						class="theme-main-color d-flex justify-content-start"
						*ngIf="!isMobile"
					>
						<div
							class="vw-5 align-self-start text-start hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							mwlCalendarPreviousView
							[view]="view"
							[(viewDate)]="selectedCalendarDate"
							#prev
							(click)="previousClick(selectedCalendarDate)"
						>
							<i class="bi bi-chevron-left fs-4" aria-hidden="true"></i>
						</div>
						<div
							class="vw-30 text-center mt-2 hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							(click)="resetDateClick()"
						>
							<span class="theme-main-color"
								>Semaine {{ selectedWeek + ' : ' }}
							</span>
							<span
								*ngIf="beginDate.getMonth() === endDate.getMonth()"
								class="fw-bold"
								>{{
									beginDate.getDate() +
										'-' +
										endDate.getDate() +
										' ' +
										monthsFr[beginDate.getMonth()] +
										' ' +
										beginDate.getFullYear()
								}}
							</span>
							<span
								*ngIf="beginDate.getMonth() !== endDate.getMonth()"
								class="fw-bold"
								>{{
									beginDate.getDate() +
										' ' +
										monthsFr[beginDate.getMonth()] +
										' - ' +
										endDate.getDate() +
										' ' +
										monthsFr[endDate.getMonth()] +
										' ' +
										beginDate.getFullYear()
								}}
							</span>
						</div>
						<div
							class="vw-5 align-self-center text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							mwlCalendarNextView
							[view]="view"
							[(viewDate)]="selectedCalendarDate"
							#next
							(click)="nextClick(selectedCalendarDate)"
						>
							<i class="bi bi-chevron-right fs-4 vw-5" aria-hidden="true"></i>
						</div>
					</div>
				</div>
				<div class="row" *ngIf="isDisplayableWeekSelectorInViewMonth()">
					<div class="theme-main-color d-flex">
						<div
							class="vw-5 align-self-center text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							mwlCalendarPreviousView
							[view]="view"
							[(viewDate)]="selectedCalendarDate"
							#prev
							(click)="previousClick(selectedCalendarDate)"
						>
							<i class="bi bi-chevron-left fs-4" aria-hidden="true"></i>
						</div>
						<div
							class="vw-30 text-center mt-2 hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							(click)="resetDateClick()"
						>
							{{
								monthsFr[selectedCalendarDate.getMonth()] +
									' ' +
									selectedCalendarDate.getFullYear() | titlecase
							}}
						</div>
						<div
							class="vw-5 align-self-center text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
							mwlCalendarNextView
							[view]="view"
							[(viewDate)]="selectedCalendarDate"
							#next
							(click)="nextClick(selectedCalendarDate)"
						>
							<i class="bi bi-chevron-right fs-4" aria-hidden="true"></i>
						</div>
					</div>
				</div>
			</div>
			<!-- Sélecteur centre -->
			<div [ngClass]="isMobile ? 'col-12' : 'col-2'">
				<div
					class="row mb-3"
					*ngIf="isDisplayableCenterSelectorDropdown()"
					[ngClass]="isMobile && 'mt-4 d-flex justify-content-center'"
				>
					<div class="col-10">
						<select
							class="form-select theme-main-color"
							[(ngModel)]="selectedCenter"
							(ngModelChange)="selectedCenterChange()"
						>
							<option
								class="theme-main-color"
								*ngFor="let c of listViewableCenters"
								[ngValue]="c"
							>
								{{
									c.id !== currentUser.employee.serviceCenter.id
										? c.name
										: c.name + ' (Mon centre)'
								}}
							</option>
						</select>
					</div>
				</div>
			</div>
			<!-- SWITCH VUE-->
			<div
				*ngIf="isDisplayableViewTypeButtonZone()"
				class="col d-lg-flex"
				[ngClass]="isMobile ? 'justify-content-center' : 'justify-content-end'"
			>
				<ul class="nav">
					<li class="nav-item hand-cursor">
						<a
							class="nav-link theme-main-color"
							[ngClass]="{
								'active fw-bold border-0 border-bottom border-3 border-custom-theme':
									view === CalendarView.Week &&
									!isModeListActive?.active &&
									!isModeAvailabilityActive?.active
							}"
							(click)="changeView(CalendarView.Week)"
							>Planning</a
						>
					</li>
					<li class="nav-item hand-cursor">
						<a
							class="nav-link theme-main-color"
							[ngClass]="{
								'active fw-bold border-0 border-bottom border-3 border-custom-theme':
									isModeListActive?.active && !isModeAvailabilityActive?.active
							}"
							(click)="activateModeList()"
							>Calendrier</a
						>
					</li>
					<li
						class="nav-item hand-cursor"
						*ngIf="canDisplayAvailabilityPlanning"
					>
						<a
							class="nav-link theme-main-color"
							[ngClass]="{
								'active fw-bold border-0 border-bottom border-3 border-custom-theme':
									isModeAvailabilityActive?.active && !isModeListActive?.active
							}"
							(click)="activateModeAvailability()"
							>Disponibilités</a
						>
					</li>
				</ul>
			</div>
			<!-- Paramètres et filtres -->
			<div
				[ngClass]="
					isMobile ? 'row mt-1 ms-2' : 'd-flex col justify-content-end'
				"
			>
				<div
					class="dropdown mx-2"
					*ngIf="isDisplayableParametersAndFilterButtonZone()"
					[ngClass]="isMobile && 'col'"
				>
					<button
						type="button"
						class="btn theme-bs-light-button dropdown-toggle"
						data-bs-toggle="dropdown"
						aria-expanded="false"
						data-bs-auto-close="outside"
					>
						Affichage
					</button>
					<div
						class="dropdown-menu px-3 mb-5"
						style="width: max-content !important"
					>
						<!-- SWITCH vue alignée -->
						<span *ngIf="isDisplayableAlignedViewSwitch()">
							<div
								class="form-check form-switch d-flex ms-2 mt-2"
								[ngClass]="isMobile ? 'col-12, pb-3' : 'mx-0'"
							>
								<input
									type="checkbox"
									class="mt-0 form-check-input border-main-color"
									id="customSwitch3"
									[checked]="isAlignedWeekViewSwitchActive"
									(change)="changeAlignedWeekViewSwitch()"
									[ngClass]="{
										'theme-main-color-check': isAlignedWeekViewSwitchActive
									}"
								/>
								<label class="form-check-label" for="customSwitch3"
									>&nbsp;Vue Alignée</label
								>
							</div>
						</span>
						<!-- SWITCH vue absences -->
						<span *ngIf="isDisplayableVacationSwitch()">
							<hr class="dropdown-divider" />
							<div
								class="form-check form-switch d-flex ms-2"
								[ngClass]="isMobile ? 'col-12, pb-3' : 'mx-0'"
							>
								<input
									type="checkbox"
									class="mt-0 form-check-input border-main-color"
									id="customSwitch1"
									[checked]="isAbsenceSwitchActive"
									(change)="changeAbsenceSwitch()"
									[ngClass]="{
										'theme-main-color-check': isAbsenceSwitchActive
									}"
								/>
								<label class="form-check-label" for="customSwitch1"
									>&nbsp;Absences</label
								>
							</div>
						</span>
						<!-- SWITCH weekends -->
						<span *ngIf="isDisplayableWeekEndSwitch()">
							<hr class="dropdown-divider" />
							<div
								class="form-check form-switch d-flex ms-2"
								[ngClass]="isMobile ? 'col-12, pb-3 ' : 'mx-0'"
							>
								<input
									type="checkbox"
									class="mt-0 form-check-input border-main-color"
									id="customSwitch2"
									[checked]="isWeekendActive"
									(change)="changeWeekendSwitch()"
									[ngClass]="{ 'theme-main-color-check': isWeekendActive }"
								/>
								<label
									class="form-check-label"
									for="customSwitch2"
									[ngClass]="!isMobile && 'text-nowrap'"
									>&nbsp;Week-end</label
								>
							</div>
						</span>
						<!-- SWITCH afficher tous les employés -->
						<span *ngIf="isDisplayableAllEmployeesSwitch()">
							<hr class="dropdown-divider" />
							<div
								class="form-check form-switch d-flex ms-2"
								[ngClass]="isMobile ? 'col-12 ' : 'mx-0'"
							>
								<input
									type="checkbox"
									class="mt-0 form-check-input border-main-color"
									id="allEmpsSwitch"
									[checked]="isScheduledViewAllEmpsSwitchActive"
									(change)="changeScheduledViewAllEmpsSwitch()"
									[ngClass]="{
										'theme-main-color-check': isScheduledViewAllEmpsSwitchActive
									}"
								/>
								<label
									class="form-check-label"
									for="allEmpsSwitch"
									[ngClass]="!isMobile && 'text-nowrap'"
									>&nbsp;Tous les employés</label
								>
							</div>
						</span>
						<!-- SWITCH afficher mission non affectées -->
						<span *ngIf="isDisplayableUnassignedMissionSwitch()">
							<hr class="dropdown-divider" />
							<div
								class="form-check form-switch d-flex ms-2"
								[ngClass]="isMobile ? 'col-12 ' : 'mx-0'"
							>
								<input
									type="checkbox"
									class="mt-0 form-check-input border-main-color"
									id="unassignedMissionsSwitch"
									[checked]="isScheduledViewUnassignedMissionsSwitchActive"
									(change)="changeScheduledViewUnassignedMissionsSwitch()"
									[ngClass]="{
										'theme-main-color-check':
											isScheduledViewUnassignedMissionsSwitchActive
									}"
								/>
								<label
									class="form-check-label"
									for="unassignedMissionsSwitch"
									[ngClass]="!isMobile && 'text-nowrap'"
									>&nbsp;Non affectées</label
								>
							</div>
						</span>
						<!-- AJOUTER/RETIRER JOURS -->
						<span *ngIf="isAlignedWeekViewSwitchActive">
							<hr class="dropdown-divider" />
							<button
								type="button"
								class="btn btn-sm"
								(click)="addOrRemoveDay.emit('-')"
								data-toggle="tooltip"
								data-placement="bottom"
								title="Retirer une journée à l'affichage"
							>
								<i class="bi bi-calendar-minus fs-5" aria-hidden="true"></i>
							</button>
							Jours
							<button
								type="button"
								class="btn me-0 btn-sm"
								(click)="addOrRemoveDay.emit('+')"
								data-toggle="tooltip"
								data-placement="bottom"
								title="Ajouter une journée à l'affichage"
							>
								<i class="bi bi-calendar-plus fs-5" aria-hidden="true"></i>
							</button>
						</span>
						<!-- ZOOM VERTICAL -->
						<span *ngIf="isDisplayableZoomButtonsZone()">
							<hr class="dropdown-divider" />
							<button
								class="btn btn-sm"
								type="button"
								(click)="changeHourSegments.emit('-')"
								data-toggle="tooltip"
								data-placement="bottom"
								title="Dimninuer la taille du planning (dé-zoom)"
							>
								<i class="bi bi-zoom-out fs-5" aria-hidden="true"></i>
							</button>
							Zoom
							<button
								class="btn me-0 btn-sm"
								type="button"
								(click)="changeHourSegments.emit('+')"
								data-toggle="tooltip"
								data-placement="bottom"
								title="Augmenter la taille du planning (zoom)"
							>
								<i class="bi bi-zoom-in fs-5" aria-hidden="true"></i>
							</button>
						</span>
					</div>
				</div>
				<div
					*ngIf="!isModeListActive?.active"
					class="dropdown mx-2"
					[ngClass]="isMobile && 'col'"
				>
					<button
						type="button"
						class="btn theme-bs-light-button dropdown-toggle"
						data-bs-toggle="dropdown"
						aria-expanded="false"
						data-bs-auto-close="outside"
					>
						Filtres
					</button>
					<div class="dropdown-menu px-3" style="width: max-content !important">
						<!-- Tri intervenant -->
						<span *ngIf="isDisplayableIntervenantFilter()">
							<div class="d-flex" [ngClass]="isMobile ? 'row' : 'mx-2'">
								<div
									class="dropdown hand-cursor"
									[ngClass]="isMobile && 'col-12 mt-4'"
								>
									<span
										class="theme-main-color"
										role="button"
										id="dropdownMenuLink"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										Intervenant :
										<span class="fw-bold">{{ ddEmployee }} </span>
										<i class="bi bi-chevron-down" aria-hidden="true"></i>
									</span>

									<ul
										class="dropdown-menu overflow-auto"
										style="height: fit-content; max-height: 500px"
										aria-labelledby="dropdownMenuLink"
									>
										<li (click)="displayAllPlanning()">
											<a class="dropdown-item theme-main-color"
												>Tous
												<span
													class="badge rounded-pill theme-main-background-color text-white"
												>
													{{ getNbMission() }}
												</span>
											</a>
										</li>
										<li>
											<hr class="dropdown-divider" />
										</li>
										<li
											(click)="displayPlanningBySkill(competence)"
											*ngFor="let competence of competences"
										>
											<a class="dropdown-item theme-main-color"
												>{{ competence.name.replaceAll('_', ' ') }}
												<span
													class="badge rounded-pill theme-main-background-color text-white"
												>
													{{ getNbMissionWithCompetence(competence) }}
												</span>
											</a>
										</li>
										<li>
											<hr class="dropdown-divider" />
										</li>

										<li
											(click)="displayPlanningForEmployee(employee)"
											*ngFor="let employee of employeesList"
										>
											<a class="dropdown-item theme-main-color"
												>{{
													employee.firstName +
														' ' +
														employee.lastName.toUpperCase()
												}}
												<span
													class="badge rounded-pill theme-main-background-color text-white"
												>
													{{ getNbMissionOfEmployeePlanning(employee.id) }}
												</span>
											</a>
										</li>
									</ul>
								</div>
							</div>
							<hr class="dropdown-divider" />
						</span>
						<!-- Tri intervenant POUR LE PLANNING DES DISPONIBILITÉS SEULEMENT -->
						<span *ngIf="isDisplayableEmployeeFilterAvailabilityView()">
							<div
								class="d-flex justify-content-center align-items-center"
								[ngClass]="isMobile ? 'row' : 'mx-2'"
							>
								<div
									class="dropdown hand-cursor"
									[ngClass]="isMobile && 'col-12 mt-4'"
								>
									<span
										class="theme-main-color"
										role="button"
										id="dropdownMenuLink"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										Intervenant :
										<span class="fw-bold">{{ ddEmployee }} </span>
										<i class="bi bi-chevron-down" aria-hidden="true"></i>
									</span>

									<ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
										<li (click)="displayAllPlanningAvailability()">
											<a class="dropdown-item theme-main-color">Tous</a>
										</li>
										<li>
											<hr class="dropdown-divider" />
										</li>
										<li
											(click)="displayAvailabilityBySkill(competence)"
											*ngFor="let competence of competences"
										>
											<a class="dropdown-item theme-main-color"
												>{{ competence.name.replaceAll('_', ' ') }}
												<span
													class="badge rounded-pill theme-main-background-color text-white"
												>
													{{ getNbAvailabilityWithCompetence(competence) }}
												</span>
											</a>
										</li>
										<li>
											<hr class="dropdown-divider" />
										</li>

										<li
											(click)="displayAvailabilityForEmployee(employee)"
											*ngFor="let employee of employeesList"
										>
											<a class="dropdown-item theme-main-color"
												>{{
													employee.firstName +
														' ' +
														employee.lastName.toUpperCase()
												}}
												<span
													class="badge rounded-pill theme-main-background-color text-white"
												>
													{{ getNbAvailabilityOfEmployee(employee.id) }}
												</span>
											</a>
										</li>
									</ul>
								</div>
							</div>
							<hr class="dropdown-divider" />
						</span>
						<!-- FIN DE "Tri intervenant POUR LE PLANNING DES INDISPONIBILITÉS SEULEMENT" -->

						<!-- Tri bénéficiaire liste déroulante -->
						<span *ngIf="isDisplayableBeneficiaireFilterDropdown()">
							<div [ngClass]="isMobile ? 'row' : 'mx-2'">
								<div
									class="dropdown hand-cursor"
									[ngClass]="isMobile && 'col-12 mt-4'"
								>
									<span
										class="theme-main-color"
										role="button"
										id="dropdownMenuLink"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										Bénéficiaire :
										<span class="fw-bold">{{ ddBeneficiaire }} </span>
										<i class="bi bi-chevron-down" aria-hidden="true"></i>
									</span>

									<ul
										class="dropdown-menu overflow-auto"
										style="height: fit-content; max-height: 500px"
										aria-labelledby="dropdownMenuLink"
									>
										<li (click)="displayAllPlanning()">
											<a class="dropdown-item theme-main-color">Tous</a>
										</li>
										<hr class="dropdown-divider" />

										<li
											(click)="displayPlanningForBeneficiaire(beneficiaire)"
											*ngFor="let beneficiaire of listBeneficiaires"
										>
											<a
												class="dropdown-item theme-main-color"
												[ngClass]="!isViewTourneesSwitchActive && 'disabled'"
												>{{ beneficiaire.firstName }}
												{{
													beneficiaire.lastName === 'public'
														? beneficiaire.lastName
														: beneficiaire.lastName.toUpperCase()
												}}
											</a>
										</li>
									</ul>
								</div>
							</div>
							<hr class="dropdown-divider" />
						</span>

						<!-- Tri missionType liste déroulante -->
						<span *ngIf="isDisplayableMissionTypeDropdown()">
							<div [ngClass]="isMobile ? 'row' : 'mx-2'">
								<div
									class="dropdown hand-cursor"
									[ngClass]="isMobile && 'col-12 mt-4'"
								>
									<span
										class="theme-main-color"
										role="button"
										id="dropdownMenuLink"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										{{ labelIntervention | titlecase }} :
										<span class="fw-bold">{{ ddFormation }} </span>
										<i class="bi bi-chevron-down" aria-hidden="true"></i>
									</span>

									<ul
										class="dropdown-menu overflow-auto"
										style="height: fit-content; max-height: 500px"
										aria-labelledby="dropdownMenuLink"
									>
										<li (click)="displayAllPlanning()">
											<a class="dropdown-item theme-main-color">Tous</a>
										</li>
										<hr class="dropdown-divider" />

										<li
											(click)="displayPlanningByMissionType(missionType)"
											*ngFor="let missionType of listMissionTypes"
										>
											<a
												class="dropdown-item theme-main-color"
												[ngClass]="!isViewTourneesSwitchActive && 'disabled'"
												>{{ missionType.type }}
											</a>
										</li>
									</ul>
								</div>
							</div>
							<hr class="dropdown-divider" />
						</span>

						<!-- Tri service liste déroulante -->
						<span *ngIf="isDisplayableCenterDepartmentDropdown()">
							<div [ngClass]="isMobile ? 'row' : 'mx-2'">
								<div
									class="dropdown hand-cursor"
									[ngClass]="isMobile && 'col-12 mt-4'"
								>
									<span
										class="theme-main-color"
										role="button"
										id="dropdownMenuLink"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										Service :
										<span class="fw-bold">{{ ddCenterDepartment }} </span>
										<i class="bi bi-chevron-down" aria-hidden="true"></i>
									</span>

									<ul
										class="dropdown-menu overflow-auto"
										style="height: fit-content; max-height: 500px"
										aria-labelledby="dropdownMenuLink"
									>
										<li (click)="displayAllPlanning()">
											<a class="dropdown-item theme-main-color">Tous</a>
										</li>
										<hr class="dropdown-divider" />

										<li
											(click)="
												displayPlanningByCenterDepartment(centerDepartment)
											"
											*ngFor="let centerDepartment of listCenterDepartments"
										>
											<a
												class="dropdown-item theme-main-color"
												[ngClass]="!isViewTourneesSwitchActive && 'disabled'"
												>{{ centerDepartment.name }}
											</a>
										</li>
									</ul>
								</div>
							</div>
							<hr class="dropdown-divider" />
						</span>

						<!-- Tri missionPlace liste déroulante -->
						<span *ngIf="isDisplayableMissionPlaceDropdown()">
							<div [ngClass]="isMobile ? 'row' : 'mx-2'">
								<div
									class="dropdown hand-cursor"
									[ngClass]="isMobile && 'col-12 mt-4'"
								>
									<span
										class="theme-main-color"
										role="button"
										id="dropdownMenuLink"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										{{ 'Lieu' | titlecase }} :
										<span class="fw-bold">{{ ddMissionPlace }} </span>
										<i class="bi bi-chevron-down" aria-hidden="true"></i>
									</span>

									<ul
										class="dropdown-menu overflow-auto"
										style="height: fit-content; max-height: 500px"
										aria-labelledby="dropdownMenuLink"
									>
										<li (click)="displayAllPlanning()">
											<a class="dropdown-item theme-main-color">Tous</a>
										</li>
										<hr class="dropdown-divider" />

										<li
											(click)="displayPlanningByMissionPlace(missionPlace)"
											*ngFor="let missionPlace of listMissionPlaces"
										>
											<a
												class="dropdown-item theme-main-color"
												[ngClass]="!isViewTourneesSwitchActive && 'disabled'"
												>{{ missionPlace.nameDisplay }}
											</a>
										</li>
									</ul>
								</div>
							</div>
						</span>
					</div>
				</div>

				<!-- LOADER QUAND ON EST EN VUE MOBILE (SITUÉ AU DESSUS DU PLANNING)-->
				<div
					class="col text-center justify-content-center mt-3"
					*ngIf="isDisplayableLoaderForMobile()"
				>
					<div class="lds-dual-ring"></div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #validatePlanningModal>
	<div class="modal-header">
		<h4 class="modal-title pull-left">Validation du Planning</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			[hidden]="this.copyButtonDisabled"
			(click)="modalRefVerouillage?.hide()"
		>
			<!-- <span aria-hidden="true" class="visually-hidden">&times;</span> -->
		</button>
	</div>
	<div class="modal-body">Êtes vous sûr de vouloir valider le planning ?</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button mx-2"
			(click)="modalRefVerouillage?.hide()"
		>
			Annuler
		</button>
		<button
			type="button"
			class="btn theme-green-button mx-2"
			[disabled]="!(this.solution || this.redirectedSolution)"
			(click)="validatePlanning()"
		>
			Valider
		</button>
	</div>
</ng-template>

<ng-template #invalidatePlanningModal>
	<div class="modal-header">
		<h4 class="modal-title pull-left">Déverrouillage du Planning</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalRefDeverouillage?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		Êtes vous sûr de vouloir déverrouiller le planning ?
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button mx-2"
			(click)="modalRefDeverouillage?.hide()"
		>
			Annuler
		</button>
		<button
			type="button"
			class="btn theme-green-button mx-2"
			(click)="invalidatePlanning()"
		>
			Déverrouiller
		</button>
	</div>
</ng-template>

<ng-template #copyingDataModal>
	<div class="modal-header">
		<h4 class="modal-title pull-left">Recopie du planning</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			[hidden]="this.copyButtonDisabled"
			(click)="templateCopyingData?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		Sur quelle semaine souhaitez vous copier le planning actuel ?

		<div class="row">
			<div class="col-6">
				<div class="input-group">
					<span class="input-group-text" id="basic-addon1">Semaine :</span>
					<input
						type="number"
						min="1"
						max="54"
						class="form-control"
						[(ngModel)]="weekNumberSelectedForCopy"
						placeholder="{{ dateUtils.getWeekNumber(today) + 2 }}"
						aria-label=""
						aria-describedby="weekNumberSelectedForCopy"
						(change)="
							weekNumberSelectedForCopy < 1
								? (weekNumberSelectedForCopy =
										dateUtils.getWeekNumber(today) + 1)
								: weekNumberSelectedForCopy;
							weekNumberSelectedForCopy > 54
								? (weekNumberSelectedForCopy =
										dateUtils.getWeekNumber(today) + 1)
								: weekNumberSelectedForCopy
						"
					/>
				</div>
			</div>
			<div class="col-6">
				<div class="input-group">
					<span class="input-group-text" id="selectYear">Année :</span>
					<input
						type="number"
						class="form-control"
						[(ngModel)]="selectedYearNumberForCopy"
						aria-label=""
						aria-describedby="selectedYearNumberForCopy"
					/>
				</div>
			</div>
		</div>

		<div class="row mt-3">
			<div class="alert alert-warning text-center" role="alert">
				Attention ! Si il y a des conflits lors de la copie, les missions de la
				semaine sélectionnée seront conservées.
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button mx-2"
			(click)="templateCopyingData?.hide()"
		>
			Annuler
		</button>
		<button
			[disabled]="
				copyButtonDisabled ||
				(selectedWeek === weekNumberSelectedForCopy &&
					selectedYear === selectedYearNumberForCopy) ||
				weekNumberSelectedForCopy > 54 ||
				weekNumberSelectedForCopy < 1
			"
			type="button"
			class="btn theme-green-button mx-2"
			(click)="copyPlanning()"
		>
			<div
				class="spinner-border theme-main-color"
				role="status"
				*ngIf="copyButtonDisabled"
			>
				<span class="visually-hidden">Loading...</span>
			</div>
			<span *ngIf="copyButtonDisabled">Copie en cours...</span>

			<span *ngIf="!copyButtonDisabled">Copier le planning</span>
		</button>
	</div>
</ng-template>

<ng-template #optimizationReport>
	<div class="modal-header text-center d-block">
		<h4 class="modal-title d-inline-block">Rapport de planification</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalRefOptimizationReport?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<table class="table text-center">
			<caption>
				Rapport de planification
			</caption>
			<thead>
				<tr>
					<th scope="col">Critères</th>
					<th scope="col">Poids du critère</th>
					<th scope="col">Solution initiale</th>
					<th scope="col">Solution finale</th>
					<th scope="col">Gain (%)</th>
					<th scope="col">Gain brut</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let report of displayedCriteriaReport">
					<th scope="row">{{ reportLabelEnum[report.label] }}</th>
					<td>{{ report.weight }}</td>
					<td>
						{{ report.initialValue + ' ' + report.unit }}
					</td>
					<td>
						{{ report.finalValue + ' ' + report.unit }}
					</td>
					<td
						[ngClass]="
							report.gain > 0
								? 'fw-bold positive-gain'
								: report.gain !== 0
								? 'fw-bold negative-gain'
								: 'fw-bold'
						"
					>
						<i
							*ngIf="report.gain > 0"
							class="bi bi-arrow-up-right"
							aria-hidden="true"
						></i>
						<i
							*ngIf="report.gain < 0"
							class="bi bi-arrow-down-right"
							aria-hidden="true"
						></i>
						{{ report.gain + ' %' }}
					</td>
					<td>
						{{ report.gainDelta + ' ' + report.unit }}
					</td>
				</tr>
			</tbody>
		</table>
		<button
			type="button"
			class="btn theme-main-color-button"
			(click)="displayAdditionalInfo()"
		>
			{{ displayAdditionalInfoButtonLabel }}
		</button>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button mx-2"
			(click)="modalRefOptimizationReport?.hide()"
		>
			Retour
		</button>
	</div>
</ng-template>

<ng-template #solutionNotesModal>
	<div class="modal-header">
		<h4 class="modal-title pull-left">Notes de coordination</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalRefSolutionNotes?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<textarea
			class="form-control"
			id="inputNotes"
			[(ngModel)]="solution.notes"
			[readonly]="isMobile || !isSolutionNotesEditing"
			[rows]="textareaLineCount"
		></textarea>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button mx-2"
			(click)="modalRefSolutionNotes?.hide()"
		>
			Annuler
		</button>
		<button
			*ngIf="!isMobile && !isSolutionNotesEditing"
			type="button"
			class="btn theme-green-button mx-2"
			(click)="isSolutionNotesEditing = true"
		>
			Editer
		</button>
		<button
			*ngIf="!isMobile && isSolutionNotesEditing"
			type="button"
			class="btn theme-green-button"
			(click)="updateSolutionNotes()"
		>
			Valider
		</button>
	</div>
</ng-template>

<ng-template #tmpOptimReportsModal>
	<app-select-solution
		[modalRefTmpOptimReports]="modalRefTmpOptimReports"
		[displayAdditionalInfoButtonLabel]="displayAdditionalInfoButtonLabel"
		[displayAdditionalInfoButtonLabelInactive]="
			displayAdditionalInfoButtonLabelInactive
		"
		[displayAdditionalInfoButtonLabelActive]="
			displayAdditionalInfoButtonLabelActive
		"
		[selectedCalendarDate]="selectedCalendarDate"
		[tmpOptimReports]="tmpOptimReports"
		(getDataForPlanning)="getDataForPlanning.emit($event)"
	></app-select-solution>
</ng-template>

<ng-template #exportCalendarModal>
	<div class="modal-header">
		<h4 class="modal-title">Exportation d'agenda</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalRefExportCalendar?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<h5>Lien d'abonnement (Google Agenda, Outlook, iCalendar...) :</h5>
		<div class="input-group pt-4 pb-4 d-flex justify-content-center">
			<span class="input-group-text" id="basic-addon3"
				>https://isyplanning.isycare-technology.com/subscribe/{{
					currentLoggedInEmployeeId
				}}</span
			>
		</div>
		<h5 class="mb-3">Exporter :</h5>
		<div class="row m-3">
			<button class="btn theme-main-color-button" (click)="exportAgendaICal()">
				Exporter en format Google/Outlook Agenda
			</button>
		</div>
		<div class="row m-3">
			<button class="btn theme-main-color-button" (click)="exportAgendaCsv()">
				Exporter en format .CSV
			</button>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button mx-2"
			(click)="modalRefExportCalendar?.hide()"
		>
			Retour
		</button>
	</div>
</ng-template>
